'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _getPrototypeOf = require('babel-runtime/core-js/object/get-prototype-of');

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = require('babel-runtime/helpers/classCallCheck');

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = require('babel-runtime/helpers/createClass');

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = require('babel-runtime/helpers/possibleConstructorReturn');

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = require('babel-runtime/helpers/inherits');

var _inherits3 = _interopRequireDefault(_inherits2);

var _JPlayer2 = require('./JPlayer');

var _JPlayer3 = _interopRequireDefault(_JPlayer2);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var JPlayerMobilePlayer = function (_JPlayer) {
  (0, _inherits3.default)(JPlayerMobilePlayer, _JPlayer);

  function JPlayerMobilePlayer() {
    (0, _classCallCheck3.default)(this, JPlayerMobilePlayer);
    return (0, _possibleConstructorReturn3.default)(this, (JPlayerMobilePlayer.__proto__ || (0, _getPrototypeOf2.default)(JPlayerMobilePlayer)).apply(this, arguments));
  }

  (0, _createClass3.default)(JPlayerMobilePlayer, [{
    key: 'destroy',

    /**
     * Overriding the JPlayer's destroy method to keep
     * the JPlayerMobilePlayer from destroying itself
     * since it is loaded as a singleton. (See JPlayerFactory.)
     */
    value: function destroy() {
      this.jPlayerLibrary.off();
      this.jPlayerLibrary.jPlayer('clearMedia');
    }
  }]);
  return JPlayerMobilePlayer;
}(_JPlayer3.default);

exports.default = JPlayerMobilePlayer;
//# sourceMappingURL=JPlayerMobilePlayer.js.map